<template>
    <div class="row">
        <div class="col-md-12">
            <div class="bsp-grey">
                <div class="row mb-1"> 
                    <div class="col-md-auto">{{ data[0]?.Tahun ?? (selectedyears[0] ?? '-') }}</div> 
                    <div class="col"><span class="text-center w-100" style="font-size:10px;">{{ title }}</span></div>
                </div>
                <div class="row">
                    <div class="col">
                        <div class="d-flex align-items-center mb-2 ms-1"><div class="w-100 text-right">Rp. {{ formatNum(data[0]?.Waste ?? 0) }}</div></div>
                        <div>{{ data[1]?.Tahun ?? (selectedyears[1] ?? '-') }}</div>
                        <div class="d-flex align-items-center mb-1"><div class="w-100 text-right">Rp. {{ formatNum(data[1]?.Waste ?? 0) }}</div></div>
                    </div>
                    <div class="col-md-auto text-center ps-2 me-2 mt-3">
                        <div>{{ formatNum((((data[0]?.Waste ?? 0)-(data[1]?.Waste ?? 0))/(data[0]?.Waste ?? 0)) * 100) }}%</div>
                        <div><i class="fa fa-money bsp-icon-grey"></i></div>
                    </div>										
                </div>
                <div class="text-center">WASTE (Jt IDR)</div>
            </div>
            <Loader v-if="loading" />
        </div>
    </div>
</template>


<script>
import BarCard from '@/views/pages/BarCard.vue'
import ListItem from '@/views/pages/ListItem.vue'
import ListCompare from '@/views/pages/ListCompare.vue'
import Fuel from '@/components/page/Fuel.js'
import Footer from '@/views/Footer.vue'
import PieChart from '@/components/chart/Pie.js'
import { Rainbow, Rainbow3, Penanggalan, AppColors, Config, AxiosWithJar } from '@/utility.js'
import Loader from '@/components/loader/Loader2.vue'

export default{
	extends: Fuel,
	components:{
		Loader,
		//ListItem,
		//ListCompare,
		//BarCard,
		//PieChart,
		//Footer            
	},
	props: {
        title: {
            type: String,
            default: 'NET SALES',
            //required: false,
        },
        year: {
            type: String,
            default: '2024',
            //required: false,
        },
        area: {
            type: String,
            default: '',
            //required: false,
        },
        amount :{
            type: String,
            default: '0',
            //required: false,
        },
        years: {
            type: Array,
            default: () => ['2024'],
            //required: false,
        },
        data: {
			type: Array,
			default: () => []
		},
        loading: {
            type: Boolean,
            default: false,
        },
    },
	data() {
		return {
            selectedyears : this.years.slice().sort((a, b) => b - a), //this.years,
			reportdata: [],
            value: 0,
            /*
			loading: {
				table: false,
				chart: false,
			},
            */
		}
	},
	watch: {
        years: {
            handler(newVal) {
                this.selectedyears = newVal.slice().sort((a, b) => b - a);
            },
            immediate: true,
            deep: true
        }
	}, 
	computed: {
        /*
		totalOutstanding() {
			return this.reportdata.data.reduce((sum, item) => sum + item.Count, 0);
		},
        */
	},

    mounted() {
		//this.getData();
    },
    methods:{
		
	}
}
</script>



<style>
.bsp-grey {
	background-color: #DAE3F3; 
	border-radius:6px; 
	border-left: 20px solid #2F5597;
	padding: 6px 8px;
	color: #2F5597;
	font-weight: bold;
}

.bsp-icon-grey {
	font-size:30px;
}

.text-ellipsis {
    white-space: nowrap;         /* Mencegah teks membungkus ke baris berikutnya */
    overflow: hidden;            /* Menyembunyikan teks yang melebihi lebar kontainer */
    text-overflow: ellipsis;
}
</style>